// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================
   MOBILE HEATMAP GRID — sticky-column heatmap
   Sticky-left strike column + synced horizontally-scrolling cell
   strips per row + a sticky-top column header.
   Scoped to small-width viewports AND short-height landscape phones
   (e.g. iPhone 14 Pro 852×393 in landscape) — desktop unaffected.
   ============================================ */

@media (max-width: 768px),
       (max-height: 500px) and (orientation: landscape) {
  .mhg-root {
    position: relative;
    background: #0E1424;
    border-top: 0.5px solid rgba(255,255,255,0.1);
    border-bottom: 0.5px solid rgba(255,255,255,0.1);
    color: #ffffff;
  }

  /* Column-header row — sticky to top of the heatmap container */
  .mhg-header-row {
    display: flex;
    align-items: stretch;
    background: #141823;
    border-bottom: 0.5px solid rgba(255,255,255,0.1);
    position: sticky;
    top: 0;
    z-index: 2;
    height: 50px;
  }

  /* Actions column (★ ➕ ➖) — sits to the left of the strike column. */
  .mhg-actions-col {
    flex: 0 0 36px;
    width: 36px;
    min-width: 36px;
    max-width: 36px;
    background: #141823;
    border-right: 0.5px solid rgba(255,255,255,0.08);
    padding: 6px 4px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 4px;
  }

  .mhg-actions-col-header {
    /* Empty header cell — same width / surface as the column below. */
  }

  .mhg-action-btn {
    width: 24px;
    height: 24px;
    background: transparent;
    border: 1px solid rgba(255,255,255,0.1);
    border-radius: 6px;
    color: rgba(255,255,255,0.7);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    padding: 0;
    -webkit-tap-highlight-color: transparent;
    flex-shrink: 0;
    transition: background-color 0.12s ease, transform 0.08s ease, color 0.12s ease, border-color 0.12s ease;
  }

  .mhg-action-btn:active {
    background: rgba(255,255,255,0.06);
    transform: scale(0.92);
  }

  .mhg-action-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  .mhg-action-btn-favorited {
    color: #facc15;
    border-color: #facc15;
    background: rgba(250,204,21,0.1);
  }

  .mhg-action-btn-remove:active {
    border-color: #ef4444;
    color: #ef4444;
    background: rgba(239,68,68,0.1);
  }

  .mhg-action-spinner {
    width: 10px;
    height: 10px;
    border: 2px solid rgba(255,255,255,0.25);
    border-top-color: #218aff;
    border-radius: 50%;
    animation: mhg-spin 0.8s linear infinite;
  }

  @keyframes mhg-spin {
    to { transform: rotate(360deg); }
  }

  .mhg-strike-col {
    flex: 0 0 124px;
    width: 124px;
    min-width: 124px;
    max-width: 124px;
    background: #141823;
    border-right: 0.5px solid rgba(255,255,255,0.08);
    padding: 8px 10px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 3px;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
    transition: background-color 0.12s ease;
  }

  .mhg-strike-col:active {
    background: #1b2030;
  }

  .mhg-strike-col:focus-visible {
    outline: 2px solid #218aff;
    outline-offset: -2px;
  }

  .mhg-header-row .mhg-strike-col {
    justify-content: center;
    gap: 2px;
  }

  .mhg-strike-col-label-line1 {
    font-size: 10px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: rgba(255,255,255,0.5);
    line-height: 1;
  }

  .mhg-strike-col-label-line2 {
    font-size: 11px;
    font-weight: 500;
    color: rgba(255,255,255,0.65);
    line-height: 1.2;
  }

  /* Cell strip (header + each row) */
  .mhg-strip {
    flex: 1 1;
    overflow-x: auto;
    overflow-y: hidden;
    display: flex;
    align-items: stretch;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    /* Right-edge peek-fade — signals "more cells, swipe" */
    mask-image: linear-gradient(to right, black, black calc(100% - 14px), transparent);
  }

  .mhg-strip::-webkit-scrollbar { display: none; }

  /* Column-header cell (within the sticky header row) — flex-grow so cells
     fill any extra horizontal space (landscape phones, fewer scenarios).
     Min stays at 58px so portrait with 7+ scenarios still overflows/scrolls. */
  .mhg-col-header {
    flex: 1 0 58px;
    min-width: 58px;
    max-width: 120px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 11px;
    font-weight: 500;
    letter-spacing: 0.4px;
    color: rgba(255,255,255,0.55);
    text-transform: uppercase;
  }

  /* Contract rows */
  .mhg-row {
    display: flex;
    align-items: stretch;
    border-bottom: 0.5px solid rgba(255,255,255,0.08);
  }

  .mhg-row:last-child {
    border-bottom: none;
  }

  /* Strike column header — ticker + position-type pill + kebab */
  .mhg-strike-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 4px;
    min-height: 18px;
  }

  .mhg-strike-ticker {
    font-size: 11px;
    font-weight: 600;
    color: #FFFFFF;
    line-height: 1.2;
    white-space: nowrap;
    /* Ticker must always be fully visible — never shrink under flex
       pressure from the BUY/SELL pill or any sibling. */
    flex-shrink: 0;
  }

  .mhg-strike-position {
    font-size: 10px;
    font-weight: 500;
    letter-spacing: 0.04em;
    color: rgba(255,255,255,0.7);
    padding: 1px 5px;
    background: rgba(255,255,255,0.06);
    border-radius: 3px;
    margin-left: auto;
    /* If space runs short (e.g. 5-char ticker + SELL), the pill is the
       buffer — it ellipsises rather than the ticker. */
    flex-shrink: 1;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  /* Strike value row — value + inline OTM/ITM percent */
  .mhg-strike-strike {
    display: flex;
    align-items: baseline;
    gap: 6px;
  }

  .mhg-strike-value {
    font-size: 15px;
    font-weight: 600;
    color: #FFFFFF;
    line-height: 1.15;
    /* Allow the strike to truncate gracefully if needed */
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .mhg-strike-pct {
    font-size: 11px;
    font-weight: 500;
    color: rgba(255,255,255,0.65);
    line-height: 1.15;
    white-space: nowrap;
  }

  /* OTM/ITM chip inside strike column */
  .mhg-strike-chip {
    align-self: flex-start;
    font-size: 11px;
    font-weight: 500;
    color: #34D399;
    background: rgba(16,185,129,0.16);
    border: 0.5px solid rgba(16,185,129,0.35);
    border-radius: 4px;
    padding: 1px 6px;
    line-height: 1.2;
  }

  .mhg-strike-prem {
    font-size: 11px;
    line-height: 1.2;
  }

  .mhg-strike-prem-label {
    color: rgba(255,255,255,0.5);
  }

  .mhg-strike-prem-value {
    color: #FFFFFF;
    font-weight: 500;
  }

  /* Expiration line under the premium row */
  .mhg-strike-exp {
    font-size: 11px;
    line-height: 1.2;
    color: rgba(255,255,255,0.65);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  /* Heat cell — flex-grow so cells fill any extra horizontal space (landscape
     phones, fewer scenarios). Min stays at 58px so portrait with 7+ scenarios
     still overflows/scrolls. Max-width caps growth so cells don't get absurd. */
  .mhg-cell {
    flex: 1 0 58px;
    min-width: 58px;
    max-width: 120px;
    padding: 7px 4px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    line-height: 1.1;
    -webkit-tap-highlight-color: transparent;
    /* bg + fg come from inline style via colorFor() */
  }

  .mhg-cell[role="button"]:active {
    opacity: 0.85;
  }

  .mhg-cell[role="button"]:focus-visible {
    outline: 2px solid #218aff;
    outline-offset: -2px;
  }

  .mhg-cell-top {
    font-size: 11px;
    opacity: 0.78;
    margin-bottom: 1px;
  }

  .mhg-cell-bottom {
    font-size: 14px;
    font-weight: 600;
    font-variant-numeric: tabular-nums;
  }

  /* Inline-press feedback on cells */
  .mhg-cell:active {
    filter: brightness(1.1);
  }
}

/* ============================================
   LANDSCAPE TIGHTENING
   Layered on top of the rules above when the phone is rotated to
   landscape and the viewport is short. Halves per-row height so 5-6
   rows fit in a ~310px landscape body instead of ~3.
   ============================================ */
@media (max-height: 500px) and (orientation: landscape) {
  .mhg-header-row {
    height: 34px;
    min-height: 34px;
  }

  /* Hard-cap row height — prevents the cell strip's align-items: stretch from
     forcing rows tall when an ancestor's flex layout would otherwise allocate
     extra height to children. overflow:hidden guards against any single
     overrun. */
  .mhg-row {
    max-height: 58px;
    min-height: 0;
    overflow: hidden;
  }

  .mhg-strike-col {
    padding: 4px 8px;
    gap: 1px;
    /* Strike column is no longer the tallest child once content is tight;
       constrain explicitly so the row max-height isn't fought by intrinsic
       sizing. */
    max-height: 58px;
  }

  .mhg-strike-head {
    min-height: 14px;
  }

  .mhg-strike-ticker {
    font-size: 10px;
  }

  .mhg-strike-position {
    font-size: 9px;
    padding: 0 4px;
  }

  .mhg-strike-value {
    font-size: 13px;
    line-height: 1.1;
  }

  .mhg-strike-pct,
  .mhg-strike-exp {
    font-size: 10px;
    line-height: 1.15;
  }

  /* Hide the premium line in landscape — saves a row line. The current
     premium is still visible via the chart-detail modal on row tap, and the
     contract identity (ticker/strike/exp) is the more load-bearing info. */
  .mhg-strike-prem {
    display: none;
  }

  .mhg-col-header {
    font-size: 10px;
    /* Tighter cap in landscape — cells stay readable but don't waste space */
    max-width: 100px;
  }

  .mhg-cell {
    padding: 4px 4px;
    max-width: 100px;
  }

  .mhg-cell-top {
    font-size: 10px;
    margin-bottom: 0;
  }

  .mhg-cell-bottom {
    font-size: 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/MobileHeatmapGrid.css"],"names":[],"mappings":"AAAA;;;;;;iDAMiD;;AAEjD;;EAEE;IACE,kBAAkB;IAClB,mBAAmB;IACnB,6CAA6C;IAC7C,gDAAgD;IAChD,cAAc;EAChB;;EAEA,+DAA+D;EAC/D;IACE,aAAa;IACb,oBAAoB;IACpB,mBAAmB;IACnB,gDAAgD;IAChD,gBAAgB;IAChB,MAAM;IACN,UAAU;IACV,YAAY;EACd;;EAEA,oEAAoE;EACpE;IACE,cAAc;IACd,WAAW;IACX,eAAe;IACf,eAAe;IACf,mBAAmB;IACnB,gDAAgD;IAChD,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,kEAAkE;EACpE;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,uCAAuC;IACvC,kBAAkB;IAClB,4BAA4B;IAC5B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,UAAU;IACV,wCAAwC;IACxC,cAAc;IACd,wGAAwG;EAC1G;;EAEA;IACE,kCAAkC;IAClC,sBAAsB;EACxB;;EAEA;IACE,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,qBAAqB;IACrB,gCAAgC;EAClC;;EAEA;IACE,qBAAqB;IACrB,cAAc;IACd,+BAA+B;EACjC;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,wCAAwC;IACxC,yBAAyB;IACzB,kBAAkB;IAClB,wCAAwC;EAC1C;;EAEA;IACE,KAAK,yBAAyB,EAAE;EAClC;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,gDAAgD;IAChD,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;IACR,eAAe;IACf,wCAAwC;IACxC,uCAAuC;EACzC;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;IAC1B,oBAAoB;EACtB;;EAEA;IACE,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,yBAAyB;IACzB,qBAAqB;IACrB,4BAA4B;IAC5B,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,6BAA6B;IAC7B,gBAAgB;EAClB;;EAEA,mCAAmC;EACnC;IACE,SAAO;IACP,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,oBAAoB;IACpB,iCAAiC;IACjC,qBAAqB;IACrB,uDAAuD;IAE/C,kFAAkF;EAC5F;;EAEA,gCAAgC,aAAa,EAAE;;EAE/C;;+EAE6E;EAC7E;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,6BAA6B;IAC7B,yBAAyB;EAC3B;;EAEA,kBAAkB;EAClB;IACE,aAAa;IACb,oBAAoB;IACpB,iDAAiD;EACnD;;EAEA;IACE,mBAAmB;EACrB;;EAEA,+DAA+D;EAC/D;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,QAAQ;IACR,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB;wDACoD;IACpD,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,4BAA4B;IAC5B,gBAAgB;IAChB,kCAAkC;IAClC,kBAAkB;IAClB,iBAAiB;IACjB;uDACmD;IACnD,cAAc;IACd,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA,sDAAsD;EACtD;IACE,aAAa;IACb,qBAAqB;IACrB,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,sDAAsD;IACtD,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,6BAA6B;IAC7B,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA,sCAAsC;EACtC;IACE,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,iCAAiC;IACjC,yCAAyC;IACzC,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA,0CAA0C;EAC1C;IACE,eAAe;IACf,gBAAgB;IAChB,6BAA6B;IAC7B,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;;gFAE8E;EAC9E;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;IAChB,wCAAwC;IACxC,kDAAkD;EACpD;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;IAC1B,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,kCAAkC;EACpC;;EAEA,mCAAmC;EACnC;IACE,uBAAuB;EACzB;AACF;;AAEA;;;;;iDAKiD;AACjD;EACE;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;;;eAGa;EACb;IACE,gBAAgB;IAChB,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,QAAQ;IACR;;gBAEY;IACZ,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;;IAEE,eAAe;IACf,iBAAiB;EACnB;;EAEA;;2EAEyE;EACzE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,yEAAyE;IACzE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* ============================================\n   MOBILE HEATMAP GRID — sticky-column heatmap\n   Sticky-left strike column + synced horizontally-scrolling cell\n   strips per row + a sticky-top column header.\n   Scoped to small-width viewports AND short-height landscape phones\n   (e.g. iPhone 14 Pro 852×393 in landscape) — desktop unaffected.\n   ============================================ */\n\n@media (max-width: 768px),\n       (max-height: 500px) and (orientation: landscape) {\n  .mhg-root {\n    position: relative;\n    background: #0E1424;\n    border-top: 0.5px solid rgba(255,255,255,0.1);\n    border-bottom: 0.5px solid rgba(255,255,255,0.1);\n    color: #ffffff;\n  }\n\n  /* Column-header row — sticky to top of the heatmap container */\n  .mhg-header-row {\n    display: flex;\n    align-items: stretch;\n    background: #141823;\n    border-bottom: 0.5px solid rgba(255,255,255,0.1);\n    position: sticky;\n    top: 0;\n    z-index: 2;\n    height: 50px;\n  }\n\n  /* Actions column (★ ➕ ➖) — sits to the left of the strike column. */\n  .mhg-actions-col {\n    flex: 0 0 36px;\n    width: 36px;\n    min-width: 36px;\n    max-width: 36px;\n    background: #141823;\n    border-right: 0.5px solid rgba(255,255,255,0.08);\n    padding: 6px 4px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 4px;\n  }\n\n  .mhg-actions-col-header {\n    /* Empty header cell — same width / surface as the column below. */\n  }\n\n  .mhg-action-btn {\n    width: 24px;\n    height: 24px;\n    background: transparent;\n    border: 1px solid rgba(255,255,255,0.1);\n    border-radius: 6px;\n    color: rgba(255,255,255,0.7);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    padding: 0;\n    -webkit-tap-highlight-color: transparent;\n    flex-shrink: 0;\n    transition: background-color 0.12s ease, transform 0.08s ease, color 0.12s ease, border-color 0.12s ease;\n  }\n\n  .mhg-action-btn:active {\n    background: rgba(255,255,255,0.06);\n    transform: scale(0.92);\n  }\n\n  .mhg-action-btn:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n\n  .mhg-action-btn-favorited {\n    color: #facc15;\n    border-color: #facc15;\n    background: rgba(250,204,21,0.1);\n  }\n\n  .mhg-action-btn-remove:active {\n    border-color: #ef4444;\n    color: #ef4444;\n    background: rgba(239,68,68,0.1);\n  }\n\n  .mhg-action-spinner {\n    width: 10px;\n    height: 10px;\n    border: 2px solid rgba(255,255,255,0.25);\n    border-top-color: #218aff;\n    border-radius: 50%;\n    animation: mhg-spin 0.8s linear infinite;\n  }\n\n  @keyframes mhg-spin {\n    to { transform: rotate(360deg); }\n  }\n\n  .mhg-strike-col {\n    flex: 0 0 124px;\n    width: 124px;\n    min-width: 124px;\n    max-width: 124px;\n    background: #141823;\n    border-right: 0.5px solid rgba(255,255,255,0.08);\n    padding: 8px 10px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    gap: 3px;\n    cursor: pointer;\n    -webkit-tap-highlight-color: transparent;\n    transition: background-color 0.12s ease;\n  }\n\n  .mhg-strike-col:active {\n    background: #1b2030;\n  }\n\n  .mhg-strike-col:focus-visible {\n    outline: 2px solid #218aff;\n    outline-offset: -2px;\n  }\n\n  .mhg-header-row .mhg-strike-col {\n    justify-content: center;\n    gap: 2px;\n  }\n\n  .mhg-strike-col-label-line1 {\n    font-size: 10px;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    color: rgba(255,255,255,0.5);\n    line-height: 1;\n  }\n\n  .mhg-strike-col-label-line2 {\n    font-size: 11px;\n    font-weight: 500;\n    color: rgba(255,255,255,0.65);\n    line-height: 1.2;\n  }\n\n  /* Cell strip (header + each row) */\n  .mhg-strip {\n    flex: 1;\n    overflow-x: auto;\n    overflow-y: hidden;\n    display: flex;\n    align-items: stretch;\n    -webkit-overflow-scrolling: touch;\n    scrollbar-width: none;\n    /* Right-edge peek-fade — signals \"more cells, swipe\" */\n    -webkit-mask-image: linear-gradient(to right, black, black calc(100% - 14px), transparent);\n            mask-image: linear-gradient(to right, black, black calc(100% - 14px), transparent);\n  }\n\n  .mhg-strip::-webkit-scrollbar { display: none; }\n\n  /* Column-header cell (within the sticky header row) — flex-grow so cells\n     fill any extra horizontal space (landscape phones, fewer scenarios).\n     Min stays at 58px so portrait with 7+ scenarios still overflows/scrolls. */\n  .mhg-col-header {\n    flex: 1 0 58px;\n    min-width: 58px;\n    max-width: 120px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 11px;\n    font-weight: 500;\n    letter-spacing: 0.4px;\n    color: rgba(255,255,255,0.55);\n    text-transform: uppercase;\n  }\n\n  /* Contract rows */\n  .mhg-row {\n    display: flex;\n    align-items: stretch;\n    border-bottom: 0.5px solid rgba(255,255,255,0.08);\n  }\n\n  .mhg-row:last-child {\n    border-bottom: none;\n  }\n\n  /* Strike column header — ticker + position-type pill + kebab */\n  .mhg-strike-head {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 4px;\n    min-height: 18px;\n  }\n\n  .mhg-strike-ticker {\n    font-size: 11px;\n    font-weight: 600;\n    color: #FFFFFF;\n    line-height: 1.2;\n    white-space: nowrap;\n    /* Ticker must always be fully visible — never shrink under flex\n       pressure from the BUY/SELL pill or any sibling. */\n    flex-shrink: 0;\n  }\n\n  .mhg-strike-position {\n    font-size: 10px;\n    font-weight: 500;\n    letter-spacing: 0.04em;\n    color: rgba(255,255,255,0.7);\n    padding: 1px 5px;\n    background: rgba(255,255,255,0.06);\n    border-radius: 3px;\n    margin-left: auto;\n    /* If space runs short (e.g. 5-char ticker + SELL), the pill is the\n       buffer — it ellipsises rather than the ticker. */\n    flex-shrink: 1;\n    min-width: 0;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  /* Strike value row — value + inline OTM/ITM percent */\n  .mhg-strike-strike {\n    display: flex;\n    align-items: baseline;\n    gap: 6px;\n  }\n\n  .mhg-strike-value {\n    font-size: 15px;\n    font-weight: 600;\n    color: #FFFFFF;\n    line-height: 1.15;\n    /* Allow the strike to truncate gracefully if needed */\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  .mhg-strike-pct {\n    font-size: 11px;\n    font-weight: 500;\n    color: rgba(255,255,255,0.65);\n    line-height: 1.15;\n    white-space: nowrap;\n  }\n\n  /* OTM/ITM chip inside strike column */\n  .mhg-strike-chip {\n    align-self: flex-start;\n    font-size: 11px;\n    font-weight: 500;\n    color: #34D399;\n    background: rgba(16,185,129,0.16);\n    border: 0.5px solid rgba(16,185,129,0.35);\n    border-radius: 4px;\n    padding: 1px 6px;\n    line-height: 1.2;\n  }\n\n  .mhg-strike-prem {\n    font-size: 11px;\n    line-height: 1.2;\n  }\n\n  .mhg-strike-prem-label {\n    color: rgba(255,255,255,0.5);\n  }\n\n  .mhg-strike-prem-value {\n    color: #FFFFFF;\n    font-weight: 500;\n  }\n\n  /* Expiration line under the premium row */\n  .mhg-strike-exp {\n    font-size: 11px;\n    line-height: 1.2;\n    color: rgba(255,255,255,0.65);\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  /* Heat cell — flex-grow so cells fill any extra horizontal space (landscape\n     phones, fewer scenarios). Min stays at 58px so portrait with 7+ scenarios\n     still overflows/scrolls. Max-width caps growth so cells don't get absurd. */\n  .mhg-cell {\n    flex: 1 0 58px;\n    min-width: 58px;\n    max-width: 120px;\n    padding: 7px 4px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    line-height: 1.1;\n    -webkit-tap-highlight-color: transparent;\n    /* bg + fg come from inline style via colorFor() */\n  }\n\n  .mhg-cell[role=\"button\"]:active {\n    opacity: 0.85;\n  }\n\n  .mhg-cell[role=\"button\"]:focus-visible {\n    outline: 2px solid #218aff;\n    outline-offset: -2px;\n  }\n\n  .mhg-cell-top {\n    font-size: 11px;\n    opacity: 0.78;\n    margin-bottom: 1px;\n  }\n\n  .mhg-cell-bottom {\n    font-size: 14px;\n    font-weight: 600;\n    font-variant-numeric: tabular-nums;\n  }\n\n  /* Inline-press feedback on cells */\n  .mhg-cell:active {\n    filter: brightness(1.1);\n  }\n}\n\n/* ============================================\n   LANDSCAPE TIGHTENING\n   Layered on top of the rules above when the phone is rotated to\n   landscape and the viewport is short. Halves per-row height so 5-6\n   rows fit in a ~310px landscape body instead of ~3.\n   ============================================ */\n@media (max-height: 500px) and (orientation: landscape) {\n  .mhg-header-row {\n    height: 34px;\n    min-height: 34px;\n  }\n\n  /* Hard-cap row height — prevents the cell strip's align-items: stretch from\n     forcing rows tall when an ancestor's flex layout would otherwise allocate\n     extra height to children. overflow:hidden guards against any single\n     overrun. */\n  .mhg-row {\n    max-height: 58px;\n    min-height: 0;\n    overflow: hidden;\n  }\n\n  .mhg-strike-col {\n    padding: 4px 8px;\n    gap: 1px;\n    /* Strike column is no longer the tallest child once content is tight;\n       constrain explicitly so the row max-height isn't fought by intrinsic\n       sizing. */\n    max-height: 58px;\n  }\n\n  .mhg-strike-head {\n    min-height: 14px;\n  }\n\n  .mhg-strike-ticker {\n    font-size: 10px;\n  }\n\n  .mhg-strike-position {\n    font-size: 9px;\n    padding: 0 4px;\n  }\n\n  .mhg-strike-value {\n    font-size: 13px;\n    line-height: 1.1;\n  }\n\n  .mhg-strike-pct,\n  .mhg-strike-exp {\n    font-size: 10px;\n    line-height: 1.15;\n  }\n\n  /* Hide the premium line in landscape — saves a row line. The current\n     premium is still visible via the chart-detail modal on row tap, and the\n     contract identity (ticker/strike/exp) is the more load-bearing info. */\n  .mhg-strike-prem {\n    display: none;\n  }\n\n  .mhg-col-header {\n    font-size: 10px;\n    /* Tighter cap in landscape — cells stay readable but don't waste space */\n    max-width: 100px;\n  }\n\n  .mhg-cell {\n    padding: 4px 4px;\n    max-width: 100px;\n  }\n\n  .mhg-cell-top {\n    font-size: 10px;\n    margin-bottom: 0;\n  }\n\n  .mhg-cell-bottom {\n    font-size: 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
